/* istanbul ignore file */
import React from 'react';

import { MenuItemSkeleton } from '@lumapps/lumx-menu/components/Menu/Skeleton/MenuItemSkeleton';
import { Suspense } from '@lumapps/lumx-suspense/components/Suspense';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { SettingsMenuModulesSpacesProps } from './SettingsMenuModulesSpaces';

const LazySettingsMenuModulesSpaces = React.lazy(async () => {
    const resolved = await import(
        /* webpackChunkName: 'settings-menu-modules-spaces' */
        './SettingsMenuModulesSpaces'
    );

    return { default: resolved.SettingsMenuModulesSpaces };
});

const SettingsMenuModulesSpaces = (props: SettingsMenuModulesSpacesProps) => {
    const { translateKey } = useTranslate();

    return (
        <Suspense loadingFallback={<MenuItemSkeleton hasIcon loadingMessage={translateKey(GLOBAL.LOADING)} />}>
            <LazySettingsMenuModulesSpaces {...props} />
        </Suspense>
    );
};

export { SettingsMenuModulesSpaces };
